import React from 'react'
import { useSelector } from 'react-redux'

export default function usePlayerBalance() {
  const playerBalance = useSelector((state) => state.lobby.balance);

  if (!playerBalance) {
    console.warn('Player balance missing. ', playerBalance);
    return {}
  }

  return playerBalance
}
